export default "__VITE_ASSET__U6N1jrxe__"